import { swalError, swalSuccess } from "../../../helpers/swal";
import * as requestFromServer from "./recruitementRequest";
import { callTypes, actions } from "./recruitementSlice";
import { objectKeyReplace } from "../../../helpers/objectKeyReplace";
import { logout } from "../../../modules/Auth/redux/authReducer";

export const createEducation = (payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createEducation(payload)
    .then((response) => {
      if (response.data.success) {
        swalSuccess("Education Added");
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("someting went wrong");
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateEducation = (payload, applicantId, id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateEducation(payload, applicantId, id)
    .then((response) => {
      if (response.data.success) {
        swalSuccess("Education Updated");
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("someting went wrong");
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteEducation = (itemId, id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteEducation(itemId, id)
    .then((response) => {
      if (response.data.success) {
        swalSuccess("Education Deleted");
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("someting went wrong");
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllEducationLavel = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllEducationLavel()
    .then((response) => {
      if (response.data.success) {
        const educationLavel = response.data?.data?.hrms_education_level?.map(
          (item) => {
            return {
              value: item?.hrms_education_level__id,
              label: item?.hrms_education_level__name,
            };
          }
        );
        dispatch(
          actions.educationLavelFetched({
            educationLavel,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("someting went wrong");
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

// export const getApplicantsInfoById = (id) => (dispatch) => {
//   dispatch(actions.startCall({ callType: callTypes.action }));
//   return requestFromServer
//     .getApplicantsInfoById(id)
//     .then((res) => {
//       if (res?.data?.success) {
//         if (res?.data?.data) {
//           dispatch(
//             actions.applicantsInfoFetched({
//               applicantsInfo: res?.data?.data,
//             })
//           );
//         } else {
//           if (res.data.message) {
//             swalError(res.data.message);
//           }
//         }
//       } else {
//         dispatch(logout({}));
//       }
//     })
//     .catch((error) => {
//       // error.clientMessage = "Can't create buy";
//       dispatch(actions.catchError({ error, callType: callTypes.action }));
//     });
// };

export const setApplicantsInfo = (payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return dispatch(
    actions.applicantsInfoFetched({
      applicantsInfo: payload,
    })
  );
};

export const updateApplicantsInfoKey = (payload) => (dispatch, getState) => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  const currentInfo = getState().publicApplicant.applicantsInfo || {};

  const updatedInfo = {
    ...currentInfo,
    ...payload, // this will add or replace the key(s)
  };

  return dispatch(
    actions.applicantsInfoFetched({
      applicantsInfo: updatedInfo,
    })
  );
};

export const setApplicantsPublicationSummeryKey =
  (payload) => (dispatch, getState) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    const currentInfo = getState().publicApplicant.publicationCommonData || {};

    const updatedInfo = {
      ...currentInfo,
      ...payload, // this will add or replace the key(s)
    };

    return dispatch(
      actions.publicationCommonDataFethced({
        publicationCommonData: updatedInfo,
      })
    );
  };

export const removeApplicantsPublicationSummeryKey =
  () => (dispatch, getState) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    return dispatch(
      actions.publicationCommonDataFethced({
        publicationCommonData: {},
      })
    );
  };

export const setApplicantsPermanentAddressInfo = (payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return dispatch(
    actions.applicantsPermanentInfoFetched({
      permanent: payload,
    })
  );
};

export const setApplicantsPresentAddressInfo = (payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return dispatch(
    actions.applicantsPresentInfoFetched({
      present: payload,
    })
  );
};

export const getAllEducationByApplicants = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getEducationByApplicantId(id)
    .then((response) => {
      if (response?.data?.data?.hrms_education) {
        const resData = response?.data?.data?.hrms_education;
        var result = resData?.map(function (o) {
          return objectKeyReplace(o, "hrms_education__");
        });
        dispatch(
          actions.educationListFetched({
            educationList: result,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("someting went wrong");
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const setEducationByApplicants = (payload) => (dispatch, getState) => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  const existingList = getState().publicApplicant.educationList || [];

  return dispatch(
    actions.educationListFetched({
      educationList: [...existingList, payload],
    })
  );
};

export const removeEducationByApplicants = () => (dispatch, getState) => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  return dispatch(
    actions.educationListFetched({
      educationList: [],
    })
  );
};

export const updateEducationByApplicants =
  (payload, id) => (dispatch, getState) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    const existingList = getState().publicApplicant.educationList?.filter(
      (item) => item?.id != id
    );

    return dispatch(
      actions.educationListFetched({
        educationList: [...existingList, payload],
      })
    );
  };

export const deleteEducationByApplicants = (id) => (dispatch, getState) => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  const existingList = getState().publicApplicant.educationList?.filter(
    (item) => item?.id != id
  );

  return dispatch(
    actions.educationListFetched({
      educationList: [...existingList],
    })
  );
};

export const getProfessionalCertificatesByApplicants = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getprofesionalCertificatesByApplicantId(id)
    .then((response) => {
      if (response?.data?.data?.hrms_professional_certification) {
        const resData = response?.data?.data?.hrms_professional_certification;
        var result = resData?.map(function (o) {
          return objectKeyReplace(o, "hrms_professional_certification__");
        });
        dispatch(
          actions.profesionalCertificatesListFetched({
            profesionalCertificatesList: result,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("someting went wrong");
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const setProfessionalCertificatesByApplicants =
  (payload) => (dispatch, getState) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    const existingList =
      getState().publicApplicant.profesionalCertificatesList || [];

    return dispatch(
      actions.profesionalCertificatesListFetched({
        profesionalCertificatesList: [...existingList, payload],
      })
    );
  };

export const removeProfessionalCertificatesByApplicants =
  () => (dispatch, getState) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    return dispatch(
      actions.profesionalCertificatesListFetched({
        profesionalCertificatesList: [],
      })
    );
  };

export const updateProfessionalCertificatesByApplicants =
  (payload, id) => (dispatch, getState) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    const existingList =
      getState().publicApplicant.profesionalCertificatesList?.filter(
        (item) => item?.id != id
      );

    return dispatch(
      actions.profesionalCertificatesListFetched({
        profesionalCertificatesList: [...existingList, payload],
      })
    );
  };

export const deleteProfessionalCertificatesByApplicants =
  (id) => (dispatch, getState) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    const existingList =
      getState().publicApplicant.profesionalCertificatesList?.filter(
        (item) => item?.id != id
      );

    return dispatch(
      actions.profesionalCertificatesListFetched({
        profesionalCertificatesList: [...existingList],
      })
    );
  };

export const getExperienceByApplicants = (id, query) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getExperienceByApplicantId(id, query)
    .then((response) => {
      if (response?.data?.data?.hrms_experience) {
        const resData = response?.data?.data?.hrms_experience;

        var result = resData?.map(function (o) {
          return objectKeyReplace(o, "hrms_experience__");
        });
        dispatch(
          actions.experienceFetched({
            experienceList: result,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("someting went wrong");
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const setExperienceByApplicants = (payload) => (dispatch, getState) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  const existingList = getState().publicApplicant.experienceList || [];

  return dispatch(
    actions.experienceFetched({
      experienceList: [...existingList, payload],
    })
  );
};

export const removeExperienceByApplicants = () => (dispatch, getState) => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  return dispatch(
    actions.experienceFetched({
      experienceList: [],
    })
  );
};

export const updateExperienceByApplicants =
  (payload, id) => (dispatch, getState) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    const existingList = getState().publicApplicant.experienceList?.filter(
      (item) => item?.id != id
    );

    return dispatch(
      actions.experienceFetched({
        experienceList: [...existingList, payload],
      })
    );
  };

export const deleteExperienceByApplicants = (id) => (dispatch, getState) => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  const existingList = getState().publicApplicant.experienceList?.filter(
    (item) => item?.id != id
  );

  return dispatch(
    actions.experienceFetched({
      experienceList: [...existingList],
    })
  );
};

export const getTrainingByApplicants = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getTrainingByApplicantId(id)
    .then((response) => {
      if (response?.data?.data?.hrms_training) {
        const resData = response?.data?.data?.hrms_training;
        var result = resData?.map(function (o) {
          return objectKeyReplace(o, "hrms_training__");
        });
        dispatch(
          actions.trainingFetched({
            trainingList: result,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("someting went wrong");
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const setTrainingByApplicants = (payload) => (dispatch, getState) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  const existingList = getState().publicApplicant.trainingList || [];

  return dispatch(
    actions.trainingFetched({
      trainingList: [...existingList, payload],
    })
  );
};

export const removeTrainingByApplicants = () => (dispatch, getState) => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  return dispatch(
    actions.trainingFetched({
      trainingList: [],
    })
  );
};

export const updateTrainingByApplicants =
  (payload, id) => (dispatch, getState) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    const existingList = getState().publicApplicant.trainingList?.filter(
      (item) => item?.id != id
    );

    return dispatch(
      actions.trainingFetched({
        trainingList: [...existingList, payload],
      })
    );
  };

export const deleteTrainingByApplicants = (id) => (dispatch, getState) => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  const existingList = getState().publicApplicant.trainingList?.filter(
    (item) => item?.id != id
  );

  return dispatch(
    actions.trainingFetched({
      trainingList: [...existingList],
    })
  );
};

export const getSpecialisationByApplicants = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getSpecialisationByApplicantId(id)
    .then((response) => {
      if (response?.data?.data?.hrms_specialisation) {
        const resData = response?.data?.data?.hrms_specialisation;
        var result = resData?.map(function (o) {
          return objectKeyReplace(o, "hrms_specialisation__");
        });
        dispatch(
          actions.specialisationFetched({
            specialisationList: result,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("someting went wrong");
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAdditionalInfoByApplicants = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAdditionalInfoByApplicantId(id)
    .then((response) => {
      if (response?.data?.data?.hrms_additional_information) {
        var resData = response?.data?.data?.hrms_additional_information;
        console.log({ resData });
        var result = resData?.map(function (o) {
          return objectKeyReplace(o, "hrms_additional_information__");
        });
        dispatch(
          actions.additionalInfoFetched({
            additionalInfo: result,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("someting went wrong");
        }
      }
    })
    .catch((error) => {
      console.log({ error });
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getRelativesInfoByApplicants = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getRelativesInfoByApplicantId(id)
    .then((response) => {
      if (response?.data?.data?.hrms_applicant_relative_information) {
        var resData = response?.data?.data?.hrms_applicant_relative_information;
        var result = resData?.map(function (o) {
          return objectKeyReplace(o, "hrms_applicant_relative_information__");
        });
        dispatch(
          actions.relativesInfoFetched({
            relativesInfo: result,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("someting went wrong");
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateRelativesInfo = (param) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateRelativesInfo(param)
    .then((response) => {
      console.log(response);
      // if (response.data.success) {
      //     swalSuccess("Data Updated!!!");
      // } else {
      //     if (response.data.message) {
      //         swalError(response.data.message);
      //     } else {
      //         swalError("someting went wrong");
      //     }
      // }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteRelativesInfo = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteRelativesInfo()
    .then((response) => {
      console.log(response);
      // if (response.data.success) {
      //     swalSuccess("Data Updated!!!");
      // } else {
      //     if (response.data.message) {
      //         swalError(response.data.message);
      //     } else {
      //         swalError("someting went wrong");
      //     }
      // }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getReferenceInfoByApplicants = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getReferenceInfoByApplicantId(id)
    .then((response) => {
      if (response?.data?.data?.hrms_references) {
        const resData = response?.data?.data?.hrms_references;
        var result = resData?.map(function (o) {
          return objectKeyReplace(o, "hrms_references__");
        });
        dispatch(
          actions.referenceInfoFetched({
            referenceInfo: result,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("someting went wrong");
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const setReferenceInfoByApplicants =
  (payload) => (dispatch, getState) => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    const existingList = getState().publicApplicant.referenceInfo || [];

    return dispatch(
      actions.referenceInfoFetched({
        referenceInfo: [...existingList, payload],
      })
    );
  };

export const removeReferenceInfoByApplicants = () => (dispatch, getState) => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  return dispatch(
    actions.referenceInfoFetched({
      referenceInfo: [],
    })
  );
};

export const updateReferenceInfoByApplicants =
  (payload, id) => (dispatch, getState) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    const existingList = getState().publicApplicant.referenceInfo?.filter(
      (item) => item?.id != id
    );

    return dispatch(
      actions.referenceInfoFetched({
        referenceInfo: [...existingList, payload],
      })
    );
  };

export const deleteReferenceInfoByApplicants = (id) => (dispatch, getState) => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  const existingList = getState().publicApplicant.referenceInfo?.filter(
    (item) => item?.id != id
  );

  return dispatch(
    actions.referenceInfoFetched({
      referenceInfo: [...existingList],
    })
  );
};

export const getLanguageInfoByApplicants = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getLanguageInfoByApplicantId(id)
    .then((response) => {
      if (response?.data?.data?.hrms_language_proficiency) {
        const resData = response?.data?.data?.hrms_language_proficiency;
        var result = resData?.map(function (o) {
          return objectKeyReplace(o, "hrms_language_proficiency__");
        });
        dispatch(
          actions.languageInfoFetched({
            languageInfo: result,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("someting went wrong");
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const setLanguageInfoByApplicants =
  (payload) => (dispatch, getState) => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    const existingList = getState().publicApplicant.languageInfo || [];

    return dispatch(
      actions.languageInfoFetched({
        languageInfo: [...existingList, payload],
      })
    );
  };

export const removeLanguageInfoByApplicants = () => (dispatch, getState) => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  return dispatch(
    actions.languageInfoFetched({
      languageInfo: [],
    })
  );
};

export const updateLanguageInfoByApplicants =
  (payload, id) => (dispatch, getState) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    const existingList = getState().publicApplicant.languageInfo?.filter(
      (item) => item?.id != id
    );

    return dispatch(
      actions.languageInfoFetched({
        languageInfo: [...existingList, payload],
      })
    );
  };

export const deleteLanguageInfoByApplicants = (id) => (dispatch, getState) => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  const existingList = getState().publicApplicant.languageInfo?.filter(
    (item) => item?.id != id
  );

  return dispatch(
    actions.languageInfoFetched({
      languageInfo: [...existingList],
    })
  );
};

export const getPublicationInfoByApplicants = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getPublicationInfoByApplicantId(id)
    .then((response) => {
      if (response?.data?.data?.hrms_publication) {
        const resData = response?.data?.data?.hrms_publication;
        var result = resData?.map(function (o) {
          return objectKeyReplace(o, "hrms_publication__");
        });
        dispatch(
          actions.publicationInfoFetched({
            publicationInfo: result,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("someting went wrong");
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const setPublicationByApplicants = (payload) => (dispatch, getState) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  const existingList = getState().publicApplicant.publicationInfo || [];

  return dispatch(
    actions.publicationInfoFetched({
      publicationInfo: [...existingList, payload],
    })
  );
};

export const removePublicationByApplicants = () => (dispatch, getState) => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  return dispatch(
    actions.publicationInfoFetched({
      publicationInfo: [],
    })
  );
};

export const updatePublicationByApplicants =
  (payload, id) => (dispatch, getState) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    const existingList = getState().publicApplicant.publicationInfo?.filter(
      (item) => item?.id != id
    );

    return dispatch(
      actions.publicationInfoFetched({
        publicationInfo: [...existingList, payload],
      })
    );
  };

export const deletePublicationByApplicants = (id) => (dispatch, getState) => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  const existingList = getState().publicApplicant.publicationInfo?.filter(
    (item) => item?.id != id
  );

  return dispatch(
    actions.publicationInfoFetched({
      publicationInfo: [...existingList],
    })
  );
};

export const getPortfolioInfoByApplicants = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getPortfolioInfoByApplicantId(id)
    .then((response) => {
      if (response?.data?.data?.hrms_portfolio) {
        const resData = response?.data?.data?.hrms_portfolio;
        var result = resData?.map(function (o) {
          return objectKeyReplace(o, "hrms_portfolio__");
        });
        dispatch(
          actions.portfolioInfoFetched({
            portfolioInfo: result,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("someting went wrong");
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const setPortfolioInfoByApplicants =
  (payload) => (dispatch, getState) => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    const existingList = getState().publicApplicant.portfolioInfo || [];

    return dispatch(
      actions.portfolioInfoFetched({
        portfolioInfo: [...existingList, payload],
      })
    );
  };

export const removePortfolioInfoByApplicants = () => (dispatch, getState) => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  return dispatch(
    actions.portfolioInfoFetched({
      portfolioInfo: [],
    })
  );
};

export const updatePortfolioInfoByApplicants =
  (payload, id) => (dispatch, getState) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    const existingList = getState().publicApplicant.portfolioInfo?.filter(
      (item) => item?.id != id
    );

    return dispatch(
      actions.portfolioInfoFetched({
        portfolioInfo: [...existingList, payload],
      })
    );
  };

export const deletePortfolioInfoByApplicants = (id) => (dispatch, getState) => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  const existingList = getState().publicApplicant.portfolioInfo?.filter(
    (item) => item?.id != id
  );

  return dispatch(
    actions.portfolioInfoFetched({
      portfolioInfo: [...existingList],
    })
  );
};

export const getAllDegree = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllDegree()
    .then((response) => {
      if (response.data.success) {
        const degree = response.data?.data?.hrms_degree?.map((item) => {
          return {
            value: item?.hrms_degree__id,
            label: item?.hrms_degree__name,
          };
        });
        dispatch(
          actions.degreeFetched({
            degree,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("someting went wrong");
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllResultType = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllResultType()
    .then((response) => {
      if (response.data.success) {
        const resultType = response.data?.data?.hrms_result_type?.map(
          (item) => {
            return {
              value: item?.hrms_result_type__id,
              label: item?.hrms_result_type__name,
            };
          }
        );
        dispatch(
          actions.resultTypeFetched({
            resultType,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("someting went wrong");
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllBoard = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllBoard()
    .then((response) => {
      if (response.data.success) {
        const board = response.data?.data?.hrms_board?.map((item) => {
          return {
            value: item?.hrms_board__id,
            label: item?.hrms_board__name,
          };
        });
        dispatch(
          actions.boardFetched({
            board,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("someting went wrong");
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllInstitute = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllInstitute()
    .then((response) => {
      if (response.data.success) {
        const institute = response.data?.data?.hrms_institute?.map((item) => {
          return {
            value: item?.hrms_institute__id,
            label: item?.hrms_institute__name,
          };
        });
        dispatch(
          actions.instituteFetched({
            institute,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("someting went wrong");
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllMajorSubject = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllMajorSubject()
    .then((response) => {
      if (response.data.success) {
        const majorSubject = response.data?.data?.hrms_major_subject?.map(
          (item) => {
            return {
              value: item?.hrms_major_subject__id,
              label: item?.hrms_major_subject__name,
            };
          }
        );
        dispatch(
          actions.majorSubjectFetched({
            majorSubject,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("someting went wrong");
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getProfilePercentage = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getProfilePercentage()
    .then((response) => {
      if (response.data.success) {
        const profilePercentage = response?.data?.data?.percentage;
        dispatch(
          actions.profilePercentageFetched({
            profilePercentage,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("someting went wrong");
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const insertProfileScore = (params) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .insertProfileScore(params)
    .then((response) => {
      if (response.data.success) {
        console.log("Score saved");
      } else {
        if (response.data.message) {
          console.log(response.data.message);
        } else {
          console.log("someting went wrong");
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateProfileScore = (params) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateProfileScore(params)
    .then((response) => {
      if (response.data.success) {
        console.log("Score saved");
      } else {
        if (response.data.message) {
          console.log(response.data.message);
        } else {
          console.log("someting went wrong");
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
export const getDocumentsInfoByApplicants = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getDocumentsInfoByApplicantId(id)
    .then((response) => {
      if (response?.data?.data?.hrms_applicant_documents) {
        var resData = response?.data?.data?.hrms_applicant_documents;
        var result = resData?.map(function (o) {
          return objectKeyReplace(o, "hrms_applicant_documents__");
        });
        dispatch(
          actions.documentsInfoFetched({
            documentsInfo: result,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("someting went wrong");
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const setDocumentsInfoByApplicants =
  (payload) => (dispatch, getState) => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    const existingList = getState().publicApplicant.documentsInfo || [];

    return dispatch(
      actions.documentsInfoFetched({
        documentsInfo: [...existingList, payload],
      })
    );
  };

export const removeDocumentsInfoByApplicants = () => (dispatch, getState) => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  return dispatch(
    actions.documentsInfoFetched({
      documentsInfo: [],
    })
  );
};

export const updateDocumentsInfoByApplicants =
  (payload, id) => (dispatch, getState) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    const existingList = getState().publicApplicant.documentsInfo?.filter(
      (item) => item?.id != id
    );

    return dispatch(
      actions.documentsInfoFetched({
        documentsInfo: [...existingList, payload],
      })
    );
  };

export const deleteDocumentsInfoByApplicants = (id) => (dispatch, getState) => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  const existingList = getState().publicApplicant.documentsInfo?.filter(
    (item) => item?.id != id
  );

  return dispatch(
    actions.documentsInfoFetched({
      documentsInfo: [...existingList],
    })
  );
};

export const updateUserData = (params, id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateUserData(params, id)
    .then((response) => {
      if (response.data.success) {
        console.log("User data saved");
      } else {
        if (response.data.message) {
          console.log(response.data.message);
        } else {
          console.log("someting went wrong");
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const insertPublicationCommonData = (params) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .insertPublicationCommonData(params)
    .then((response) => {
      if (response.data.success) {
        console.log("Data saved successfully!!!");
      } else {
        if (response.data.message) {
          console.log(response.data.message);
        } else {
          console.log("someting went wrong");
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updatePublicationCommonData = (params, id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updatePublicationCommonData(params, id)
    .then((response) => {
      if (response.data.success) {
        console.log("Data updated successfully!!!");
      } else {
        if (response.data.message) {
          console.log(response.data.message);
        } else {
          console.log("someting went wrong");
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getPublicationCommonData = (applicantId) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getPublicationCommonData(applicantId)
    .then((response) => {
      if (response?.data?.data) {
        dispatch(
          actions.publicationCommonDataFethced({
            publicationCommonData: response?.data?.data,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("someting went wrong");
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllPerDistrictByDivision = (division) => (dispatch) => {
  if (!division) {
    return dispatch(
      actions.perDistrictListFetched({
        per_district: null,
      })
    );
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllDistrict(division)
    .then((response) => {
      if (response.data.success) {
        const per_district = response.data?.data?.rows?.map((item) => {
          return {
            value: item?.geo_district_id,
            label: item?.geo_district_name,
          };
        });
        dispatch(
          actions.perDistrictListFetched({
            per_district,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("something went wrong");
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getAllPerThanaDistrictByDivision =
  (division, district) => (dispatch) => {
    if (!division || !district) {
      return dispatch(
        actions.perThanaListFetched({
          per_thana: null,
        })
      );
    }

    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer
      .getAllThana(division, district)
      .then((response) => {
        if (response.data.success) {
          const per_thana = response.data?.data?.rows?.map((item) => {
            return {
              value: item?.id,
              label: item?.name,
            };
          });
          dispatch(
            actions.perThanaListFetched({
              per_thana,
            })
          );
        } else {
          if (response.data.message) {
            swalError(response.data.message);
          } else {
            swalError("something went wrong");
          }
        }
      })
      .catch((error) => {
        // error.clientMessage = "Can't create buy";
        dispatch(actions.catchError({ error, callType: callTypes.action }));
      });
  };

export const getAllPreThanaDistrictByDivision =
  (division, district) => (dispatch) => {
    if (!division && !district) {
      return dispatch(
        actions.preThanaListFetched({
          pre_thana: null,
        })
      );
    }

    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer
      .getAllThana(division, district)
      .then((response) => {
        if (response.data.success) {
          const pre_thana = response.data?.data?.rows?.map((item) => {
            return {
              value: item?.id,
              label: item?.name,
            };
          });
          dispatch(
            actions.preThanaListFetched({
              pre_thana,
            })
          );
        } else {
          if (response.data.message) {
            swalError(response.data.message);
          } else {
            swalError("something went wrong");
          }
        }
      })
      .catch((error) => {
        // error.clientMessage = "Can't create buy";
        dispatch(actions.catchError({ error, callType: callTypes.action }));
      });
  };
export const getAllPreDistrictByDivision = (division) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllDistrict(division)
    .then((response) => {
      if (response.data.success) {
        const pre_district = response.data?.data?.rows?.map((item) => {
          return {
            value: item?.geo_district_id,
            label: item?.geo_district_name,
          };
        });
        dispatch(
          actions.preDistrictListFetched({
            pre_district,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("something went wrong");
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const applicantJobProfilePercentage = (param) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .applicantJobProfilePercentage(param)
    .then((response) => {
      if (response.data.success) {
        const profile_matching = response?.data?.data?.profile_matching;
        dispatch(
          actions.profileMatchedFetched({
            profileMatched: profile_matching,
          })
        );
      } else {
        if (response.data.message) {
          console.log(response.data.message);
        } else {
          console.log("someting went wrong");
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
export const applicantDeclarationData = (applicantId) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .applicantDeclarationData(applicantId)
    .then((response) => {
      if (response.data.success) {
        const declaration_data = response?.data?.data;
        dispatch(
          actions.declarationDataFetched({
            applicantDeclarationData: declaration_data,
          })
        );
      } else {
        if (response.data.message) {
          console.log(response.data.message);
        } else {
          console.log("someting went wrong");
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const saveDeclaration = (param) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveDeclaration(param)
    .then((response) => {
      if (response.data.success) {
        console.log("Data Saved!!!");
      } else {
        if (response.data.message) {
          console.log(response.data.message);
        } else {
          console.log("someting went wrong");
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getApplicantsSocialMedia = (applicant_id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getApplicantSocialMedia(applicant_id)
    .then((response) => {
      if (response.data.success) {
        dispatch(
          actions.applicantSocialMediaFetched({
            social_medias: response.data?.data,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("something went wrong");
        }
      }
    })
    .catch((error) => {
      // error.clientMessage = "Can't create buy";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const setApplicantsSocialMedia = (payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return dispatch(
    actions.applicantSocialMediaFetched({
      social_medias: payload,
    })
  );
};
